module.exports = __webpack_public_path__ + "static/media/logo_03.da783d17.png";